// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseInput_wrapper_1-pPQ","input":"BaseInput_input_3nY_0","isCentered":"BaseInput_isCentered_2pL5a","errors":"BaseInput_errors_1qaWO"};